export const SIGNUP_SUCCESS ="SIGNUP_SUCCESS";


export const Login_Request=" Login_Request";
 export const Login_Sucess="Login_Sucess";
 export const Login_Error=" Login_Error";